import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import React from 'react'
import { Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'

import { compose } from 'recompose'
import EmployeeSelect from '../../../elements/Select/Employee/EmployeesSelect'

const { TextArea } = Input

// const StateSelect = compose(
//   withData({
//     data: [{key: 'Closed', value: 'Closed'}, {key: 'Active', value: 'Active'}],
//   }),
//   withSort,
// )(CustomSelect)
//
const ActivitiesSelect = compose(
  withSelectFetch({
    dropdown: 'controlDocs',
    name: 'activities',
    cache: false,
  }),
  withSort,
)(CustomSelect)

const DocTypesSelect = compose(
  withSelectFetch({
    dropdown: 'controlDocs',
    name: 'docTypes',
    cache: false,
  }),
  withSort,
)(CustomSelect)

const FileTypesSelect = compose(
  withSelectFetch({
    dropdown: 'controlDocs',
    name: 'fileTypes',
    cache: false,
  }),
  withSort,
)(CustomSelect)

const DistributionSelect = compose(
  withSelectFetch({
    dropdown: 'controlDocs',
    name: 'distribution',
    cache: false,
  }),
  withSort,
)(CustomSelect)

function ControlledDocForm (props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form

  const { controlledDoc, modalType, isNew } = props
  const isEdit = modalType === 'edit'

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Code">
            {getFieldDecorator('code', {
              initialValue: get(controlledDoc, 'code'),
              rules: rules.input,
            })(<Input style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Activity">
            {getFieldDecorator('activity.code', {
              initialValue: get(controlledDoc, 'activity.code'),
            })(<ActivitiesSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Doc. Type">
            {getFieldDecorator('docType.code', {
              initialValue: get(controlledDoc, 'docType.code'),
              rules: rules.input,
            })(<DocTypesSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="File Type">
            {getFieldDecorator('fileType', {
              initialValue: get(controlledDoc, 'fileType'),
            })(<FileTypesSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(controlledDoc, 'title'),
              rules: rules.input,
            })(<Input style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: get(controlledDoc, 'description'),
              rules: rules.input,
            })(<TextArea rows={6} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Process Owner">
            {getFieldDecorator('processOwner._id', {
              initialValue: get(controlledDoc, 'processOwner._id'),
              rules: rules.input,
            })(<EmployeeSelect keyAtr={'_id'} valueAtr={'name'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Company">
            {getFieldDecorator('company.code', {
              initialValue: get(controlledDoc, 'company.code'),
              rules: rules.input,
            })(<OrganisationsSelect style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Management Sponsor">
            {getFieldDecorator('mgmtSponsor._id', {
              initialValue: get(controlledDoc, 'mgmtSponsor._id'),
              rules: rules.input,
            })(<EmployeeSelect keyAtr={'_id'} valueAtr={'name'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Distribution">
            {getFieldDecorator('distribution', {
              initialValue: get(controlledDoc, 'distribution'),
            })(<DistributionSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Effective Date">
            {getFieldDecorator('effectiveDate', {
              initialValue: dateVal(controlledDoc, 'effectiveDate'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Retention (in Yrs)">
            {getFieldDecorator('retention', {
              initialValue: get(controlledDoc, 'retention'),
            })(<InputNumber style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Access Control">
            {getFieldDecorator('access', {
              initialValue: get(controlledDoc, 'access'),
              rules: rules.input,
            })(
              <TextArea
                rows={6}
                placeholder="Please state Role/Level (Read/Write/Authorise)"
                style={{ width: '100%' }}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Location of Records">
            {getFieldDecorator('recordLocation', {
              initialValue: get(controlledDoc, 'recordLocation'),
              rules: rules.input,
            })(<TextArea rows={6} placeholder="Please state Module/Area" style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

ControlledDocForm.propTypes = {}
ControlledDocForm.defaultProps = {}

export default Form.create()((ControlledDocForm))
